import type * as Types from '../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OpenPublicProjectReportMutationVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
  password: Types.Scalars['String']['input'];
}>;


export type OpenPublicProjectReportMutationPage = { readonly __typename?: 'RootMutationType', readonly openPublicProjectReport: { readonly __typename?: 'PublicProjectReportSession', readonly token: string } };


export const OpenPublicProjectReportDocument = gql`
    mutation OpenPublicProjectReport($slug: String!, $password: String!) {
  openPublicProjectReport(slug: $slug, password: $password) {
    token
  }
}
    `;
export type OpenPublicProjectReportMutationFn = Apollo.MutationFunction<OpenPublicProjectReportMutationPage, OpenPublicProjectReportMutationVariables>;

/**
 * __useOpenPublicProjectReportMutation__
 *
 * To run a mutation, you first call `useOpenPublicProjectReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenPublicProjectReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openPublicProjectReportMutation, { data, loading, error }] = useOpenPublicProjectReportMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useOpenPublicProjectReportMutation(baseOptions?: Apollo.MutationHookOptions<OpenPublicProjectReportMutationPage, OpenPublicProjectReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OpenPublicProjectReportMutationPage, OpenPublicProjectReportMutationVariables>(OpenPublicProjectReportDocument, options);
      }
export type OpenPublicProjectReportMutationHookResult = ReturnType<typeof useOpenPublicProjectReportMutation>;
export type OpenPublicProjectReportMutationResult = Apollo.MutationResult<OpenPublicProjectReportMutationPage>;
export type OpenPublicProjectReportMutationOptions = Apollo.BaseMutationOptions<OpenPublicProjectReportMutationPage, OpenPublicProjectReportMutationVariables>;